module.exports = __webpack_public_path__ + "d926ada7447d5b52b725fe59d5061a37.png";